import axios from "axios";
import React, { createContext, useEffect, useReducer, useState } from "react";
import Loading from "../components/Loading/Loading";

export const UserContext = createContext();

const initialState = {
	isLoggedIn: false,
	userDetails: {},
};

//TODO: AUTHTOKEN FROM LOCALSTORAGE
const UserContextProvider = ({ children }) => {
	const [state, dispatch] = useReducer(UserReducer, initialState);

	const [loading, setLoading] = useState(true);

	const autoLogin = async (token) => {
		const url = `${process.env.REACT_APP_BACKEND_URL}/user/details`;

		try {
			await axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then((res) => {
					setLoginTrue(res.data.user);
				});
		} catch (error) {
			// console.log(error);
			if (!error.response || error.response.status === 420) {
				autoLogOut();
			}
		}
	};

	const setLoginTrue = (data) => {
		dispatch({ type: "SET_LOGIN_TRUE", data: data });
		setLoading(false);
	};

	const setLoginFalse = () => {
		dispatch({ type: "SET_LOGIN_FALSE" });
	};

	const autoLogOut = () => {
		// console.log(localStorage);
		localStorage.clear();
		setLoginFalse();
		window.location.replace("/");
	};

	useEffect(() => {
		const token = localStorage.getItem("token");
		if (token) {
			autoLogin(token);
		} else {
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const value = {
		...state,
		setLoginTrue,
		setLoginFalse,
		setLoading,
		autoLogOut,
	};

	if (loading) {
		return <Loading />;
	}

	return <UserContext.Provider value={value}> {children} </UserContext.Provider>;
};

export default UserContextProvider;

const UserReducer = (state, action) => {
	switch (action.type) {
		case "SET_LOGIN_TRUE":
			return {
				...state,
				userDetails: action.data,
				isLoggedIn: true,
			};

		case "SET_LOGIN_FALSE":
			return {
				...state,
				userDetails: {},
				isLoggedIn: false,
			};

		default:
			return {
				...state,
			};
	}
};
